export default __webpack_public_path__ + "static/media/taf.fc30042d.svg";